export const InstructionsLoc = {
    searchMaterialPlaceholder: {
        ru: 'Поиск по инструкциям: напишите название техники или работы',
        en: 'Search for instructions: write the name of the equipment or job',
    },
    title: {
        ru: 'Схемы и инструкции',
        en: 'Schemes and instructions',
    },
    itemsNotFound: {
        ru: 'Не найдено ни одной инструкции.',
        en: 'No instructions found.',
    },
    notFound: {
        title: {
            ru: 'Не нашли нужную инструкцию?',
            en: "Didn't find the right instruction?",
        },
        detail: {
            ru: 'Запросите её у Вашего менеджера! Если таковой не окажется, мы с удовольствием создадим её для Вас',
            en: 'Request it from your manager! If it doesn’t exist, we will be happy to create it for you',
        },
        button: {
            ru: 'спросить у менеджера',
            en: 'ask the manager',
        },
    },
};
